import createReactComponent from '../createReactComponent';
export default createReactComponent('move-diagonal', 'MoveDiagonal', [["path",{"d":"M19 11V5h-6m6 0L5 19m0-6v6h6","key":"svg-0"}]]);